import React from 'react';
import { ReactRelayContext } from 'react-relay';

// TODO: make this a hook so consumers do not need to pass context

import { getSelector } from 'relay-runtime'; // To fix mask issue. See usage below

export const unmaskFragmentData = ({ relayContext, relayData, fragment }) => {
    fragment = fragment();
    // using the relay-compiler-language-typescript generates
    // graphql files with default exports, FlowGenerator generates
    // module.export instead
    const fragmentToUse = fragment && fragment.default ? fragment.default : fragment;
    const { selector } = getSelector(relayContext.variables, fragmentToUse, relayData);
    return relayContext.environment.lookup(selector).data;
};

export function injectRelayContext(Component) {
    return function InjectRelayComponent(props) {
        return (
            <ReactRelayContext.Consumer>
                {relayContext => <Component {...props} relayContext={relayContext} />}
            </ReactRelayContext.Consumer>
        );
    };
}
